module.exports = __webpack_public_path__ + "static/media/002-Dirty D 2.efe9cf26.png";